import { useParams } from 'react-router-dom';
import { useGetVariantsQuery } from '../app/api-slice';
import { LoadingPage } from './loading-page';
import { ErrorPage } from './error-page';
import { ChooseVariant } from '../view/choose-variant';
import { useMessages2 } from '../hooks/useLanguage';
import { useFamilyName } from '../hooks/navigation-names';
import { PageMetadata } from '../view/page-metadata';
import { useDataRequestLang } from '../app/main-slice';

export const ChooseVariantPage = () => {

    const { categoryId, familyId } = useParams();
    const lang = useDataRequestLang();
    const { data: variants, isLoading, isSuccess, isError, error } = useGetVariantsQuery({
        lang,
        family: familyId!
    });
    const {isLoading: isLoadingMessage, isSuccess: isSuccessMessage, messages} = useMessages2();

    const familyName = useFamilyName(categoryId!, familyId!);

    let content;
    if(isLoading || isLoadingMessage) {
        content = <LoadingPage/>;
    } else if(isSuccessMessage && categoryId && familyId && isSuccess) {
        content = <ChooseVariant categoryId={categoryId} familyId={familyId} variants={variants}/>
    } else {
        content = <ErrorPage error={error}/>
    }

    return <>
        <PageMetadata pageTitle={familyName} />
        { content }
    </>
}